<template>
  <b-modal
    id="transfer-ownership-confirm-password"
    ref="transfer-ownership-confirm-password"
    size="entry-delete"
    title="Enter your Password"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <span class="modal-title">{{ label.get("change_company_owner") }}</span>
    </div>
    <div
      class="content-wrapper password-confirm"
      :class="{ 'has-error': errorMessage }"
    >
      <p>
        {{ label.get("enter_your_password_to_confirm_your_transfer_request") }}
      </p>
      <div class="info-field">
        <input
          v-model="password"
          type="password"
          :placeholder="
            label.get('please_enter_your_password_input_placeholder')
          "
          @keydown:enter="submit"
        />
      </div>
      <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
    </div>
    <div class="modal-footer">
      <button type="submit" class="atto-btn cancel" @click="close">
        {{ label.get("cancel") }}
      </button>
      <button
        type="submit"
        class="atto-btn submit"
        :disabled="disabledSubmitButton"
        @click="submit"
      >
        {{ label.get("submit") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import UserService from "../../services/UserService";

export default {
  name: "TransferOwnershipConfirmPasswordComponent",
  data() {
    return {
      password: "",
      errorMessage: null,
      disabledSubmitButton: false,
    };
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["transfer-ownership-confirm-password"].show();
  },
  methods: {
    submit() {
      this.errorMessage = null;
      if (!this.password) {
        this.errorMessage = this.label.get(
          "please_enter_your_password_input_placeholder"
        );
        return false;
      }

      this.disabledSubmitButton = true;
      UserService.checkUserOldPassword({ old_password: this.password })
        .then(() => {
          this.$root.$emit("hideTransferOwnershipConfirmPassword", true);
        })
        .catch((error) => {
          this.disabledSubmitButton = false;
          if (error.response.data.error) {
            this.errorMessage = error.response.data.error.message[0];
          }
          this.errorMessage = this.label.get("password_is_incorrect");
        });
    },
    close() {
      this.$root.$emit("hideTransferOwnershipConfirmPassword");
    },
  },
};
</script>

<style lang="scss">
.modal-entry-delete {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.password-confirm.has-error {
          padding-bottom: 16px;
        }
      }
    }
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: "Roboto", sans-serif;
    line-height: 36px;
    color: #262626;

    &:focus {
      border-color: #00b9cb;
    }
  }
}
</style>
